module.exports = __webpack_public_path__ + "img/arrow-more.b19e6de3.svg";